import { connect } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { login } from '../../store/app/apis';
import './Login.css';

function LoginWelcome({ isLoggedin, login }) {
  const navigate = useNavigate();
  let location = useLocation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [usernameError, setUsernameError] = useState(false);

  let from = '/dashboard';

  if (location?.state?.from) {
    from = location?.state?.from?.pathname + location?.state?.from?.search;
  }
  useEffect(() => {
    if (isLoggedin) {
      navigate(from, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedin]);

  const handleSubmit = (e) => {
    e.preventDefault();
    login({ username, password })
      .then((res) => {
        setError(false);
      })
      .catch((err) => {
        console.error(err);
        setError(true);
      });
  };

  return (
    <div className="loginWelcome">
      <div className="welcome">
        <div className="login">
          <h2>Welcome to Service Monitor</h2>
          <form onSubmit={handleSubmit} className="formlogin">
            <span>
              <input
                value={username}
                id="username"
                placeholder="Enter your username"
                required
                onChange={(e) => {
                  setUsername(e.target.value);
                  setError(false);
                  setUsernameError(false);
                }}
              />
              {usernameError && <p className="errorMsg">Email is required</p>}
            </span>
            <span>
              <input
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError(false);
                }}
                placeholder="Password"
                type="password"
                id="password"
                required
              />
            </span>
            <div className="loginButton">
              <button className="logButton" onClick={handleSubmit}>
                Login
              </button>
            </div>
          </form>
          {error && <p className="errorMsg">Authentication Failed, incorrect email or password</p>}
          <div className="contactUs">
            <span>
              Want to Monitor services? <a href="#"> Contact Us</a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapState = (state) => ({
  isLoggedin: state.app.user.isLoggedin,
  isMobile: state.app.isMobile,
});

const mapDispatch = {
  login,
};

export default connect(mapState, mapDispatch)(LoginWelcome);
